import { FAIcon } from '../../Icons/Icons';
import { SelectorType, TabDesign } from '../types/enums';
import type { IconStyle, IconTheme } from '../../Icons';
import { type TabiconProps, type TabiconTheme } from './type/proptype';
import styles from './TabIcon.module.scss';

const getTabDesignClass = (design: TabDesign) => {
  switch (design) {
    case TabDesign.SOLID:
      return 'solid';
    case TabDesign.ICON_CIRCLE:
      return 'icon-circle';
    default:
      return '';
  }
};

const selectedClass = (selected: boolean) => (selected ? styles['selected'] : '');

const Tabicon = ({
  theme,
  selected = false,
  icon,
  iconStyle,
  design,
  disabled = false,
  selectorType = SelectorType.UNDERLINE,
  iconClass,
}: TabiconProps) => {
  const disabledClass = disabled ? styles['disabled'] : '';

  return (
    <>
      {icon &&
        (selectorType === SelectorType.UNDERLINE ? (
          <FAIcon
            theme={theme as IconTheme}
            iconName={icon}
            iconStyle={iconStyle as IconStyle}
            className={`${styles['icon']} ${iconClass}`}
          />
        ) : (
          <div
            className={`${styles['tab-icon-container']} ${styles[getTabDesignClass(design)]} ${selectedClass(
              selected,
            )} ${theme && selected ? styles[theme] : ''} ${disabledClass}`}
          >
            <div
              className={`${styles['icon-container']} ${styles[getTabDesignClass(design)]} ${
                theme ? styles[theme] : ''
              } ${selected && !disabled ? styles['selected-icon'] : ''} ${disabledClass}`}
            >
              <FAIcon
                theme={theme as IconTheme}
                iconName={icon}
                iconStyle={iconStyle as IconStyle}
                className={`${styles['icon']} ${iconClass} ${disabledClass}`}
              />
            </div>
          </div>
        ))}
    </>
  );
};
export default Tabicon;
export type { TabiconTheme };
